export const SET_LIST_TEMPLATE_LOADING = 'SET_LIST_TEMPLATE_LOADING';
export const GET_TEMPLATE_DATA_SUCCESS = 'GET_TEMPLATE_DATA_SUCCESS';
